import React from 'react';
import SearchFilter from './SearchFilter';
import ProductCategoryList3 from './ProductCategoryList3';
import GenderSelectFilter2 from './GenderSelectFilter2';
import FrameShapeFilter2 from './FrameShapeFilter2';
import FrameBrandFilterCategory from './FrameBrandFilterCategory';
import ProductPriceFilter from './ProductPriceFilter';
import ProductViewFilter from './ProductViewFilter';
import ProductContainer2 from './ProductContainer2';
import { useSearchParams, useParams } from 'react-router-dom';

const ShopAreaSection3 = ({ sidebarRef, active }) => {
  const [searchParams] = useSearchParams();
  const { slug } = useParams();
  const shapeId = searchParams.get("shape_id");
  const genderId = searchParams.get("gender_id");
  const brandId = searchParams.get("brand_id");
  const subcategorySlug = searchParams.get("subcategory_slug");
  const categorySlug = searchParams.get("category_slug") || slug;

  if (!categorySlug && !subcategorySlug) {
    return <div>No category or subcategory selected</div>;
  }

  return (
    <div className="shop-area">
      <div className="container">
        <div className="row gy-5 justify-content-center">
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8 col-9 col-xxs-12 order-1 order-lg-0">
            <div className={`fz-sidebar fz-sidebar-2 ${active ? "active" : ""}`} ref={sidebarRef}>
              <SearchFilter />
              <FrameBrandFilterCategory categorySlug={categorySlug} subcategorySlug={subcategorySlug} />
              <ProductCategoryList3 />
              <GenderSelectFilter2 categorySlug={categorySlug} subcategorySlug={subcategorySlug} />
              <FrameShapeFilter2 categorySlug={categorySlug} subcategorySlug={subcategorySlug} />
              {/* <ProductPriceFilter /> */}
            </div>
          </div>
          <div className="col-xl-9 col-lg-8 order-2 order-lg-1">
            <ProductViewFilter />
            <ProductContainer2
              categorySlug={categorySlug}
              subcategorySlug={subcategorySlug}
              shapeId={shapeId}
              genderId={genderId}
              brandId={brandId}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopAreaSection3;